module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/~/babel-runtime/core-js/get-iterator.js
// module id = ./node_modules/react-phone-number-input/node_modules/babel-runtime/core-js/get-iterator.js
// module chunks = 0 1 2